import type { FC } from 'react';

import { useQuickReloadSubscriber } from './useQuickReloadSubscriber';
import type { QuickReloaderType } from './QuickReloadContext';

export const QuickReloadSubscriber: FC<QuickReloaderType> = (reloaderProps) => {
	useQuickReloadSubscriber(reloaderProps);
	return null;
};
